import { useEffect } from "react";
import "./howToBlog.css";
import { Helmet } from "react-helmet";


export default function HowToBlog() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>SHOP.CO | How To Blog - Tips & Guides</title>
        <meta
          name="description"
          content="Read the SHOP.CO How To Blog for tips, tutorials, and guides on making the most of your shopping experience."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/resources/how-to-blog/"
        />
      </Helmet>
      <div className="howtoblog-container">
        <header className="howtoblog-header">
          <h1>How to Start a Blog</h1>
          <p>Your step-by-step guide to launching and growing a successful blog.</p>
        </header>

        <div className="howtoblog-section">
          <h2>1. Choose a Niche</h2>
          <p>Pick a topic you're passionate about and that people are searching for.</p>
        </div>

        <div className="howtoblog-section">
          <h2>2. Select a Blogging Platform</h2>
          <p>Use WordPress, Blogger, or any platform that fits your technical comfort level.</p>
        </div>

        <div className="howtoblog-section">
          <h2>3. Design Your Blog</h2>
          <p>Create a clean and responsive layout that matches your niche and audience.</p>
        </div>

        <div className="howtoblog-section">
          <h2>4. Write Quality Content</h2>
          <p>Focus on valuable, original content that solves problems or educates your readers.</p>
        </div>

        <div className="howtoblog-section">
          <h2>5. Promote Your Blog</h2>
          <p>Share your posts on social media, join blogging communities, and use SEO strategies.</p>
        </div>

        <div className="howtoblog-section">
          <h2>6. Monetize</h2>
          <p>Once you grow your audience, you can monetize through ads, affiliate links, or selling products.</p>
        </div>
      </div>
    </>
  );
}
